(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/pd-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/pd-card.js');
'use strict';

const Card = svs.ui.ReactCard.Card;

const PdCard = _ref => {
  let children = _ref.children,
    _ref$isFocused = _ref.isFocused,
    isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange;
  return React.createElement(Card, {
    className: "padding-bottom-1",
    expandable: true,
    expandableList: true,
    isInitalExpanded: isFocused,
    onChange: onChange
  }, children);
};
svs.myProfile.react.pages.myInformation.myInformation.components.PdCard = PdCard;

 })(window);